import {
  getTshitAndShieldResponse,
  ResponseSaveProfilePic,
  ShieldDataResponse,
  ShieldPostData,
} from '@/types/editProfile';
import { ResponseMyCampaings } from '@/types/team';
import { ResponseMyAwards } from '@/types/teamf5';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

const headers = {
  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
};

export const getAwards = axiosErrorHandler(async () => {
  const response = await axiosGdt.get<ResponseMyAwards>(
    URLs.EDITAR_CUENTA.DIPLOMAS
  );

  return response.data;
}, TEXTS.defaultError);

export const getCampaings = axiosErrorHandler(async () => {
  const response = await axiosGdt.get<ResponseMyCampaings>(
    URLs.EDITAR_CUENTA.CAMPANIAS
  );

  return response.data;
}, TEXTS.defaultError);

export const getTshirtAndShield = axiosErrorHandler(async () => {
  const response = await axiosGdt.get<getTshitAndShieldResponse>(
    URLs.EDITAR_CUENTA.GET_TSHIRT_AND_SHIELD
  );

  return response.data;
}, TEXTS.defaultError);

const parseParams = (value: ShieldPostData) => {
  return {
    param1: value.param1,
    param2: value.param2,
    param3: value.param3,
    param4: value.param4,
    param5: value.param5 || '',
  };
};

export const saveShield = axiosErrorHandler(async (value: ShieldPostData) => {
  const response = await axiosGdt.post<ShieldDataResponse>(
    URLs.EDITAR_CUENTA.POST_SHIELD,
    null,
    {
      params: parseParams(value),
      headers,
    }
  );
  return response.data;
}, TEXTS.defaultError);

export const saveTshirt = axiosErrorHandler(async (value: ShieldPostData) => {
  const response = await axiosGdt.post<ShieldDataResponse>(
    `${URLs.EDITAR_CUENTA.SAVE_TSHIRT}`,
    null,
    {
      params: parseParams(value),
      headers,
    }
  );
  return response.data;
}, TEXTS.defaultError);

/**
 * Upload foto de perfil
 */
export const saveProfilePic = axiosErrorHandler(async (blob: Blob) => {
  const formData = new FormData();

  const mimeType = blob.type || 'image/jpeg';
  const ext = mimeType === 'image/png' ? 'png' : 'jpg';

  const file = new File([blob], `profile.${ext}`, {
    type: mimeType,
  });

  formData.append('croppedImage', file, file.name);

  const response = await axiosGdt.post<ResponseSaveProfilePic>(
    URLs.EDITAR_CUENTA.SAVE_PROFILE_PIC,
    formData
  );

  return response.data;
}, TEXTS.defaultError);
